/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '../connexion/connexion.component.ngfactory';
import * as i2 from '../../../../src/app/connexion/connexion.component';
import * as i3 from '@angular/platform-browser';
import * as i4 from '@ngx-translate/core/src/translate.service';
import * as i5 from '../../../../src/app/modules/features/flag.service';
import * as i6 from '../../../../src/app/modules/auth/auth.service';
import * as i7 from '@angular/router';
import * as i8 from '../../../../src/app/order/currentOrder.service';
import * as i9 from '../../../../src/app/components/content-loggedout.component';
var styles_ContentLoggedOutComponent = [];
export var RenderType_ContentLoggedOutComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_ContentLoggedOutComponent, data: {} });
export function View_ContentLoggedOutComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'loggedout'], ['id', 'wrapper']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵeld(0, null, null, 2, 'cx-connexion', [], null, null, null, i1.View_ConnexionComponent_0, i1.RenderType_ConnexionComponent)),
        i0.ɵdid(49152, null, 0, i2.ConnexionComponent, [i3.Title, i4.TranslateService,
            i5.FlagService, i6.AuthService, i7.Router, i8.CurrentOrderService], null, null), (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n']))], null, null);
}
export function View_ContentLoggedOutComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-content-loggedout', [], null, null, null, View_ContentLoggedOutComponent_0, RenderType_ContentLoggedOutComponent)), i0.ɵdid(49152, null, 0, i9.ContentLoggedOutComponent, [i3.Title, i5.FlagService], null, null)], null, null);
}
export var ContentLoggedOutComponentNgFactory = i0.ɵccf('cx-content-loggedout', i9.ContentLoggedOutComponent, View_ContentLoggedOutComponent_Host_0, {}, {}, []);
//# sourceMappingURL=content-loggedout.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/components/content-loggedout.component.ngfactory.js
// module id = 1180
// module chunks = 0